import React, { useMemo, useCallback } from 'react';
import { getTreeStatesByAccount } from '@web-mail/util';
import useState2RM from '@web-mail/hooks/useState2ReduxMock';
import { useAppSelector } from '@web-common/state/createStore';
import { ReactComponent as MailClearIcon } from '@/images/icons/mail_clear.svg';
import { ReactComponent as FilterCloseIcon } from '@/images/icons/filter_close.svg';
import { getIn18Text } from 'api';
import { Button, Tooltip } from 'antd';
import AutoSizeOperTab, { AutoSizeOperTabItem } from '@web-mail/common/components/AutoSizeOperTab/AutoSizeOperTab';
import MailSignCheckbox from './MailSignCheckbox';
import { MAIL_SORT_ITEM } from '@web-mail/common/constant';
import classnames from 'classnames';
export const MailTagComp = (props) => {
    const { handleAllRead, operElement } = props;
    const [selected, setSelected] = useState2RM('mailListStateTab', 'doUpdateMailListStateTab');
    const [selectedKeys] = useState2RM('selectedKeys', 'doUpdateSelectedKey');
    const [tagName] = useState2RM('mailTagFolderActiveKey');
    const mailTreeStateMap = useAppSelector(state => state.mailReducer.mailTreeStateMap);
    const tagList = useMemo(() => {
        const folderState = getTreeStatesByAccount(mailTreeStateMap, selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.accountId);
        if (folderState && (folderState === null || folderState === void 0 ? void 0 : folderState.mailTagList)) {
            return folderState === null || folderState === void 0 ? void 0 : folderState.mailTagList;
        }
        return [];
    }, [mailTreeStateMap, selectedKeys]);
    const unread = useMemo(() => {
        const currentTag = tagList.find(item => item[0] === (tagName === null || tagName === void 0 ? void 0 : tagName.key));
        if (currentTag && currentTag[5]) {
            return currentTag[5];
        }
        return 0;
    }, [tagList, tagName]);
    const getAllReadBtn = useCallback(size => {
        const children = size == 2 ? getIn18Text('QUANBIAOYIDU') : React.createElement(MailClearIcon, null);
        const BtnComp = (React.createElement(Button, { "data-test-id": "mail-list-tab-mard-all-read", className: "u-mark-read sirius-no-drag", onClick: handleAllRead, loading: false, type: "link", style: { height: '26px', marginTop: '10px', padding: ' 4px 2px', minWidth: 'auto' } }, children));
        return size == 2 ? (BtnComp) : (React.createElement(Tooltip, { placement: "top", title: getIn18Text('QUANBIAOYIDU') }, BtnComp));
    }, [unread, handleAllRead]);
    return (React.createElement(AutoSizeOperTab, { className: "m-list-title m-list-filter" },
        React.createElement("div", { className: "m-list-tab" },
            React.createElement(AutoSizeOperTabItem, { tabkey: "MailSignCheckbox" },
                React.createElement("div", { className: "checkbox-wrap" },
                    React.createElement(MailSignCheckbox, null))),
            selected === MAIL_SORT_ITEM.UNREAD && (React.createElement(AutoSizeOperTabItem, { tabkey: "FilterCloseIcon", className: "m-list-filter-icon", onClick: () => {
                    setSelected('ALL');
                } },
                React.createElement(FilterCloseIcon, null))),
            selected !== MAIL_SORT_ITEM.UNREAD && unread > 0 && (React.createElement(AutoSizeOperTabItem, { tabkey: "unread" },
                React.createElement("div", { className: classnames('sirius-no-drag', 'm-list-filter-btn', 'unread-txt'), onClick: () => setSelected(MAIL_SORT_ITEM.UNREAD) },
                    React.createElement("span", { className: "text-highlight", "data-test-id": "mail-list-tab-unread" }, unread),
                    React.createElement("span", null, getIn18Text('FENGWEIDU'))))),
            selected === MAIL_SORT_ITEM.UNREAD && (React.createElement(AutoSizeOperTabItem, { tabkey: "unreadSelected" },
                React.createElement("div", { className: "m-list-filter-btn m-list-filter-btn-selected" }, getIn18Text('JINWEIDU')))),
            unread > 0 && (React.createElement(AutoSizeOperTabItem, { level: 2, tabkey: "qbyd", defaultWidth: 67, smallWidth: 17.5 }, size => getAllReadBtn(size)))),
        operElement));
};
